export function reloadWindow(): void {
  setTimeout(() => {
  (window as any).appRouter.init();
  }, 2000);
}

export function getElementById(id: string): HTMLElement {
  return document.getElementById(id) as HTMLElement;
}

export function getElementDataForEach(dataForEach: string): HTMLElement {
  return document.querySelector(`[data-for-each="${dataForEach}"]`) as HTMLElement;
}

export function getElementDataModel(dataModel: string): HTMLElement {
  return document.querySelector(`[data-model="${dataModel}"]`) as HTMLElement;
}

export function getChildElementSelector(element: HTMLElement, dataSelector: string): HTMLElement {
  return element.querySelector(`[data-selector=${dataSelector}]`) as HTMLElement;
}

export function setLoading(element: string | HTMLElement): void {
  if (typeof element === "string") {
    getElementById(`${element}_content`).classList.add("hidden");
    getElementById(`${element}_error`).classList.add("hidden");
    getElementById(`${element}_loading`).classList.remove("hidden");
  } else {
    element.classList.add("hidden");
    element.parentElement?.querySelector("img")?.remove();
    const loadingElement = document.createElement("img");
    loadingElement.src = "../assets/pizza-0.5s-182px.svg";
    loadingElement.classList.add("w-10", "mx-auto");
    element.parentElement?.appendChild(loadingElement);
  }
}

export function setSmallLoading(element: string | HTMLElement): void {
  if (typeof element === "string") {
    getElementById(`${element}_content`).classList.add("hidden");
    getElementById(`${element}_error`).classList.add("hidden");
    getElementById(`${element}_loading`).classList.remove("hidden");
  } else {
    element.classList.add("hidden");
    element.parentElement?.querySelector("img")?.remove();
    const loadingElement = document.createElement("img");
    loadingElement.src = "../assets/spinner-1s-200px.svg";
    loadingElement.classList.add("w-6", "mx-auto");
    element.parentElement?.appendChild(loadingElement);
  }
}

export function setError(element: string | HTMLElement): void {
  if (typeof element === "string") {
    getElementById(`${element}_loading`).classList.add("hidden");
    getElementById(`${element}_content`).classList.add("hidden");
    getElementById(`${element}_error`).classList.remove("hidden");
  } else {
    element.classList.add("hidden");
    element.parentElement?.querySelector("img")?.remove();
    const loadingElement = document.createElement("img");
    loadingElement.src = "../assets/exclamation.svg";
    loadingElement.classList.add("w-10", "mx-auto");
    element.parentElement?.appendChild(loadingElement);
    setTimeout(() => { setContent(element) }, 2000)
  }
}

export function setContent(element: string | HTMLElement): void {
  if (typeof element === "string") {
    getElementById(`${element}_loading`).classList.add("hidden");
    getElementById(`${element}_error`).classList.add("hidden");
    getElementById(`${element}_content`).classList.remove("hidden");
  } else {
    element.parentElement?.querySelector("img")?.remove();
    element.classList.remove("hidden");
  }
}
